import React, { useState } from 'react';
import { ChevronDown, ChevronUp, History } from 'lucide-react';
import { Badge } from '../ui/badge';

const HistorialUsuarios = ({ historial }) => {
  const [expanded, setExpanded] = useState(false);
  
  if (!historial) return null;
  
  let items = [];
  try {
    items = typeof historial === 'string' ? JSON.parse(historial) : historial;
  } catch (e) {
    return null;
  }
  
  if (!items || items.length === 0) return null;
  
  const formatFecha = (fecha) => {
    if (!fecha) return '-';
    return new Date(fecha).toLocaleString('es-ES', { 
      day: '2-digit', month: '2-digit', year: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  };
  
  const getAccionLabel = (accion) => {
    switch(accion) {
      case 'cambio_asignacion': return 'Cambio de asignación';
      case 'completada': return 'Fase completada';
      case 'email_enviado': return 'Email enviado';
      default: return accion;
    }
  };
  
  const getAccionColor = (accion) => {
    switch(accion) {
      case 'cambio_asignacion': return 'bg-blue-100 text-blue-700';
      case 'completada': return 'bg-green-100 text-green-700';
      case 'email_enviado': return 'bg-purple-100 text-purple-700';
      default: return 'bg-gray-100 text-gray-700';
    }
  };
  
  return (
    <div className="mt-3 p-3 bg-slate-50 border border-slate-200 rounded-lg">
      <button 
        className="w-full flex items-center justify-between text-sm font-medium text-slate-700"
        onClick={() => setExpanded(!expanded)}
      >
        <span className="flex items-center gap-2">
          <History className="w-4 h-4" />
          Historial de intervenciones ({items.length})
        </span>
        {expanded ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
      </button>
      
      {expanded && (
        <div className="mt-3 space-y-2">
          {items.map((item, idx) => (
            <div key={idx} className="flex items-start gap-2 text-xs p-2 bg-white rounded border">
              <div className="flex-shrink-0 w-2 h-2 mt-1.5 rounded-full bg-slate-400" />
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1">
                  <Badge className={`text-[10px] ${getAccionColor(item.accion)}`}>
                    {getAccionLabel(item.accion)}
                  </Badge>
                  <span className="text-slate-400 text-[10px]">
                    {item.fase?.replace('fase_', 'Fase ').toUpperCase()}
                  </span>
                </div>
                <div className="text-slate-600">
                  {item.accion === 'cambio_asignacion' && (
                    <span>
                      <strong>{item.usuario_anterior || 'Sin asignar'}</strong> → <strong>{item.usuario_nuevo}</strong>
                      {item.realizado_por && <span className="text-slate-400"> (por {item.realizado_por})</span>}
                    </span>
                  )}
                  {item.accion === 'completada' && (
                    <span>Por <strong>{item.usuario}</strong></span>
                  )}
                  {item.accion === 'email_enviado' && (
                    <span>A <strong>{item.destinatario}</strong> por <strong>{item.usuario}</strong></span>
                  )}
                </div>
                <div className="text-slate-400 text-[10px] mt-1">
                  {formatFecha(item.fecha)}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};


export default HistorialUsuarios;
